export const PDF_FILE_INPUT_ID = "pdfFileInput";